import { type FC } from 'react';

import { BaseIcon, type BaseIconOuterProps } from '@/components/common/icons/BaseIcon';

/** Cascade / routing glyph; 25×23 artwork (matches card + menu). */
export const CascadeGateIcon: FC<BaseIconOuterProps> = (props) => {
  return (
    <BaseIcon width={25} height={23} viewBox="0 0 25 23" {...props}>
      <path d="M16.25 22.5V18.75H11.25V6.25H8.75V10H0V0H8.75V3.75H16.25V0H25V10H16.25V6.25H13.75V16.25H16.25V12.5H25V22.5H16.25ZM2.5 2.5V7.5V2.5ZM18.75 15V20V15ZM18.75 2.5V7.5V2.5ZM18.75 7.5H22.5V2.5H18.75V7.5ZM18.75 20H22.5V15H18.75V20ZM2.5 7.5H6.25V2.5H2.5V7.5Z" />
    </BaseIcon>
  );
};
